import React from 'react';
import PropTypes from 'prop-types';

import {Box, IconButton, Typography} from 'views/components';
import {MoreHoriz} from 'views/icons';
import {Translate, translate} from 'views/module';

const ScheduleEventDisplayOncall = (props) => {
  const {visitLength, onMenuClick} = props;

  const visitLengthLabelById = React.useMemo(() => ({
    'A_FEW_HOURS': translate('schedulestep.ScheduleEventEditOncall.VisitLengthOptions.FewHours'),
    'HALF_DAY': translate('schedulestep.ScheduleEventEditOncall.VisitLengthOptions.HalfDay'),
    'A_FULL_DAY': translate('schedulestep.ScheduleEventEditOncall.VisitLengthOptions.FullDay'),
    'OVERNIGHT': translate('schedulestep.ScheduleEventEditOncall.VisitLengthOptions.Overnight'),
    'NOT_SURE_YET': translate('schedulestep.ScheduleEventEditOncall.VisitLengthOptions.NotSureYetOrByTheHour'),
  }), []);
  const displayTitle = translate('schedulestep.ScheduleEventAdd.OnCallTitle');
  const displayDuration = visitLengthLabelById[`${visitLength}`.trim()] || translate('schedulestep.ScheduleEventDisplayOncall.DurationFallback');

  return (
    <Box
      sx={{
        border: '1px dashed #C5BBB9',
        borderRadius: '24px',
        p: '32px',
        backgroundColor: 'white',
      }}
    >
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2}}>
        <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
          {displayTitle}
        </Typography>
        <IconButton
          onClick={onMenuClick}
          sx={{border: '1px solid #C5BBB9', borderRadius: '8px', p: '4px'}}
        >
          <MoreHoriz sx={{fontSize: 24}} />
        </IconButton>
      </Box>

      <Box>
        <Typography sx={{fontSize: '16px', fontWeight: 590, color: '#2D2925', lineHeight: '150%'}}>
          <Translate expression={'schedulestep.ScheduleEventDisplayOncall.DurationLabel'} />
        </Typography>
        <Typography sx={{fontSize: '16px', fontWeight: 500, color: '#2D2925A3', lineHeight: '150%'}}>
          {displayDuration}
        </Typography>
      </Box>
    </Box>
  );
};

ScheduleEventDisplayOncall.propTypes = {
  visitLength: PropTypes.string,
  onMenuClick: PropTypes.func,
};

export default React.memo(ScheduleEventDisplayOncall);
